var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Absolute, BackgroundImage, Flex, Relative, Hide } from 'pcln-design-system';
var AbsoluteOverflow = styled(Absolute)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var CropFlex = styled(function (props) { return React.createElement(Flex, __assign({}, props)); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var OnTopBackgroundImage = styled(function (props) { return React.createElement(BackgroundImage, __assign({}, props)); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  z-index: 5;\n"], ["\n  z-index: 5;\n"])));
var CroppedImage = function (_a) {
    var imageMirrorProps = _a.imageMirrorProps, imageUrl = _a.imageUrl;
    return (React.createElement(CropFlex, __assign({ justifyContent: 'center', width: '100%', height: '100%', borderRadius: 'full' }, imageMirrorProps),
        React.createElement(OnTopBackgroundImage, { width: '100%', height: '100%', image: imageUrl })));
};
/** @public */
export var props = {
    children: PropTypes.node,
    mirror: PropTypes.oneOf(['left', 'right']),
};
/** @public */
var ImageContainer = function (_a) {
    var mirror = _a.mirror, imageUrl = _a.imageUrl;
    var imageHeights = ['212px', null, null, '240px', '420px'];
    var HORIZONTAL_OFFSET = '-20%';
    var absoluteMirrorProps = mirror === 'left' ? { left: HORIZONTAL_OFFSET } : { right: HORIZONTAL_OFFSET };
    var imageMirrorProps = mirror === 'left' ? { rounded: 'right' } : { rounded: 'left' };
    return (React.createElement(React.Fragment, null,
        React.createElement(Hide, { xl: true, xxl: true },
            React.createElement(Relative, { width: '72%', height: imageHeights, left: ['14%', null, null, null, '28%'], top: '16px' },
                React.createElement(CroppedImage, { imageUrl: imageUrl, imageMirrorProps: imageMirrorProps }))),
        React.createElement(Hide, { xs: true, sm: true, md: true, lg: true },
            React.createElement(AbsoluteOverflow, __assign({ width: '97%', height: imageHeights, top: '8%' }, absoluteMirrorProps),
                React.createElement(CroppedImage, { imageUrl: imageUrl, imageMirrorProps: imageMirrorProps })))));
};
ImageContainer.propTypes = props;
ImageContainer.defaultProps = {
    mirror: 'right',
};
export { ImageContainer };
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ImageContainer.js.map